import React, { Component } from 'react';
import { Link, browserHistory, withRouter } from 'react-router';
import { getLocalStorageInfo } from '../../utils';
import config from '../../config'
class UserManageSideBar extends Component {
  constructor(props){
    super(props)
  }

  render(){
    return(
      <div className="" >
        <div className="mr-calc-sidebar" style={getLocalStorageInfo().defaultLessor && getLocalStorageInfo().defaultLessor.on_trail ? { marginTop : '-50px'} : {marginTop: '-50px'}}>
          <div className="mr-calc-heading">
           <h3>User Management</h3>
          </div>
          <ul className="list-unstyled">
            <li>
              <Link className={this.props.location.pathname.includes('/users/manage') ? 'active':'' } to="/users/manage">Users</Link>
            </li>
            <li>
              <Link className={this.props.location.pathname.includes('/users/permissions') ? 'active':'' } to="/users/permissions/">Roles</Link>
            </li>

          </ul>
        </div>
      </div>
    )
  }
}
export default withRouter(UserManageSideBar);
